import { render } from "./PlatFormCost.vue?vue&type=template&id=391bb7df&scoped=true"
import script from "./PlatFormCost.vue?vue&type=script&lang=js"
export * from "./PlatFormCost.vue?vue&type=script&lang=js"

import "./PlatFormCost.vue?vue&type=style&index=0&id=391bb7df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391bb7df"]])

export default __exports__